import * as types from './constants';

// Constant from split-auth – used to clear token on logout.
const LOG_OUT = 'LOG_OUT';

const initialState = {
  token: null,
  expiresAt: null,
  loading: false,
  errors_api: {}
};

const actions = {
  [types.GET_AI_CHAT_TOKEN_REQUEST]: state => ({
    ...state,
    loading: true,
    errors_api: {}
  }),

  [types.GET_AI_CHAT_TOKEN_DONE]: (state, { payload }) => ({
    ...state,
    loading: false,
    token: payload.token,
    expiresAt: payload.expires_at
  }),

  [types.GET_AI_CHAT_TOKEN_FAILED]: (state, { payload }) => ({
    ...state,
    loading: false,
    errors_api: payload || {}
  }),

  [types.CLEAR_AI_CHAT_TOKEN]: () => ({ ...initialState }),

  [LOG_OUT]: () => ({ ...initialState })
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
